module.exports = __webpack_public_path__ + "assets/images/upgrade-graphic-premium@2x-9793f0261f421f329c9d55b888fecce4.jpg";